<template>
    <div class="live-page coral-city-page">
        <div class="case-study">

            <h1>Coral City Camera</h1>

            <p class="meta"><strong>Miami, Florida, USA</strong></p>
            <p><strong>System:</strong> Octopus™ Pan-Tilt-Zoom Underwater Observatory</p>
            <p><strong>Application:</strong> Research, Conservation, Education & Public Engagement</p>

            <div class="pink-line"></div>

            <div class="deployment-scene" aria-hidden="true">
                <MotionMedia :src="previewVideo" />
            </div>

            <section class="deployment-live">
                <h2>Watch Live</h2>

                <div class="video-container">
                    <iframe
                        :key="$route.fullPath"
                        loading="lazy"
                        width="960"
                        height="540"
                        src="https://www.youtube.com/embed/7i8ARjIeM2k"
                        title="Coral City Camera"
                        frameborder="0"
                        allowfullscreen>
                    </iframe>
                </div>
            </section>

            <section>
                <h2>Project Overview</h2>
                <p>
                    Coral City Camera is a live underwater observatory located in Miami,
                    Florida that connects viewers around the world to an urban coral reef ecosystem.
                </p>
            </section>

            <div class="pink-line"></div>

            <section>
                <h2>The Challenge</h2>
                <p>
                    Create a long-term underwater observatory capable of supporting scientific research,
                    education, and public engagement while operating continuously in a challenging marine environment.
                </p>
            </section>

            <div class="pink-line"></div>

            <section>
                <h2>The Fathom Ocean Solution</h2>
                <ul>
                    <li>Octopus™ PTZ Underwater Observatory</li>
                    <li>Self-cleaning technology</li>
                    <li>Remote PTZ control</li>
                    <li>Continuous livestreaming</li>
                    <li>Long-term deployment</li>
                </ul>
            </section>

            <div class="pink-line"></div>

            <section>
                <h2>Impact & Results</h2>
                <ul>
                    <li>Millions of viewers</li>
                    <li>Global educational reach</li>
                    <li>Coral reef research</li>
                    <li>Conservation awareness</li>
                </ul>
            </section>

            <div class="pink-line"></div>

            <section>
                <h2>System Configuration</h2>
                <ul>
                    <li>Octopus™ PTZ System</li>
                    <li>Live YouTube integration</li>
                    <li>Remote operation</li>
                    <li>Self-cleaning optics</li>
                </ul>
            </section>

            <div class="pink-line"></div>

            <section>
                <h2>Interested in a Similar Deployment?</h2>
                <p>
                    Whether you're a marine industrial facility, coastal community, aquarium,
                    or research group, Fathom Ocean can help create a live underwater observatory
                    that supports education, conservation, and monitoring engagement.
                </p>

                <b-button @click="$router.push('/contact')">
                    Schedule a Consultation
                </b-button>
            </section>

        </div>
    </div>
</template>

<script>
import MotionMedia from '@/components/journey/MotionMedia.vue'
import previewVideo from '@/assets/videos/coralcity_small.mp4'

export default {
    name: 'CoralCityCamera',
    components: {
        MotionMedia,
    },
    data() {
        return {
            previewVideo,
        }
    },
}
</script>
